export const ORGANIZATION_ROLES = [
  'President',
  'Vice President',
  'Secretary',
  'Treasurer',
  'Public Relations / Communications',
  'Events Coordinator',
  'Membership',
  'Fundraising',
  'Historian',
  'Community Service',
  'Parliamentarian',
  'Other',
] as const;

export type OrganizationRole = typeof ORGANIZATION_ROLES[number];
